import { cn, Sidebar } from "@devhop/ui";
import { useLayout } from "../providers/LayoutProvider";

export function AppSidebar({ className, ...props }: React.ComponentProps<typeof Sidebar>) {
  const { collapsible, variant } = useLayout();
  return (
    <Sidebar
      {...props}
      className={cn("print:hidden", className)}
      collapsible={collapsible}
      variant={variant}
    />
  );
}